import { NoResultsWithButton } from "components";
import { type FC } from "react";

export interface CampaignsNoResultsProps {
  createButton?: React.ReactElement;
  filtered?: boolean;
}

const CampaignsNoResults: FC<CampaignsNoResultsProps> = ({ createButton, filtered }) => {
  return (
    <NoResultsWithButton
      title="You don't have any campaigns"
      description="Looks like you don't have any campaigns yet."
      iconClassName="fa-shield-check"
      actionButton={createButton}
      filtered={filtered}
    />
  );
};

export default CampaignsNoResults;
